  $(document).ready(function() {




      $(".more_content").hide();
         
          $(".abt_read_more").click(function(){

              $(".more_content").slideToggle(1000);
              if ($(".abt_read_more").text() == "Read More") {
                  $(this).text("Read Less")
              }
              else{
                  $(this).text("Read More")
              }
          });
  })